import { render, staticRenderFns } from "./TabInformasiProyek.vue?vue&type=template&id=4b0fd32a&scoped=true"
import script from "./TabInformasiProyek.vue?vue&type=script&lang=js"
export * from "./TabInformasiProyek.vue?vue&type=script&lang=js"
import style0 from "./TabInformasiProyek.vue?vue&type=style&index=0&id=4b0fd32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0fd32a",
  null
  
)

export default component.exports